import strFunc from "@/lib/lyg/string";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import OrderManageArea from "./order_manage";

function RowArea(props: any) {
  let myProps = {
    info: {},
    row_num: 0,
    xColumnArr: null,
    select_seq_arr: [],
    set_select_seq_arr: (inData: any) => { },
    select_show_write_page: (inData: any) => { },
    order_det_arr: [],
    select_order_det_seq_arr: [],
    set_select_order_det_seq_arr: (inData: any) => { },
    is_show_all_book:false,
    delete_order_by_ajax: (inData: any) => { },
    delete_textbook_use_by_ajax: (inData: any) => { },
    go_use_of_order_det_by_ajax: (inData: any) => { },
    go_add_order_period_by_ajax: (inData: any) => { },
    send_payt_cancel_by_ajax: (inData: any) => { },
    send_payt_send_read_by_ajax: (inData: any) => { },
    open_request_order_popup: (inData: any) => { },
    open_find_textbook_each_order_popup: (inData: any) => { },
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let info = myProps.info;
  let row_num = myProps.row_num;
  let is_select_row = false;
  if (strFunc.str_in_array(info["a_seq"], myProps.select_seq_arr) != -1) {
    is_select_row = true;
  }
  let select_stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade2' });

  const select_check_toggle = (e: any) => {
    let change_select_seq_arr = [...myProps.select_seq_arr];
    if (e.target.checked === true) {
      change_select_seq_arr.push(info["a_seq"]);
    } else {
      let new_select_seq_arr: any = [];
      for (let i = 0; i < myProps.select_seq_arr.length; i++) {
        if (myProps.select_seq_arr[i] !== info["a_seq"]) {
          new_select_seq_arr.push(myProps.select_seq_arr[i]);
        }
      }
      change_select_seq_arr = new_select_seq_arr;
    }
    myProps.set_select_seq_arr(change_select_seq_arr);
  };

  const get_td_tags = () => {
    
    let stu_grade_str = "";
    for (let i=0;i<select_stu_grade_option_arr.length;i++) {
      if(info["a_stu_grade"]==select_stu_grade_option_arr[i].value){
        stu_grade_str=select_stu_grade_option_arr[i].text;
      }
    }

    let td_tags: any = xColumnArr.x_column_list_arr.map((column: any, idx: number) => {
      let val_str: any = "";
      let td_class_name = "";
      let td_div_class_name = "row-col-div text-center";
      if (info[column["key"]] != undefined) {
        val_str = info[column["key"]];
      }
      if (column["key"] === "a_user_name") {
        //td_class_name = "click_able_td";
        val_str+=" "+stu_grade_str;
      } else if (column["key"] === "row_view_class_name") {
        if (info.class_arr) {
          let class_name_arr = [];
          for (let i = 0; i < info.class_arr.length; i++) {
            class_name_arr.push(
              info.class_arr[i]["class_name"]
            );
          }
          val_str = class_name_arr.join(" / ");;
        }
      } else if (column["key"] == "row_view_new_order") {
        val_str = (
          <button className="btn btn-dark ml-2"
            onClick={() => {
              // myProps.open_request_order_popup({
              //   stu_seq_arr: [info["a_seq"]]
              // });
              myProps.open_find_textbook_each_order_popup({
                stu_info: info
              });
            }}
          >신청</button>
        );
      } else if (column["key"] == "row_view_order_manage") {
        td_div_class_name = "";
        val_str = (
          <OrderManageArea
            info={info}
            row_num={row_num}
            order_det_arr={myProps.order_det_arr}
            select_order_det_seq_arr={myProps.select_order_det_seq_arr}
            set_select_order_det_seq_arr={myProps.set_select_order_det_seq_arr}
            is_show_all_book={myProps.is_show_all_book}
            delete_order_by_ajax={myProps.delete_order_by_ajax}
            delete_textbook_use_by_ajax={myProps.delete_textbook_use_by_ajax}
            go_use_of_order_det_by_ajax={myProps.go_use_of_order_det_by_ajax}
            go_add_order_period_by_ajax={myProps.go_add_order_period_by_ajax}
            send_payt_cancel_by_ajax={myProps.send_payt_cancel_by_ajax}
            send_payt_send_read_by_ajax={myProps.send_payt_send_read_by_ajax}
            open_request_order_popup={myProps.open_request_order_popup}
            open_find_textbook_each_order_popup={myProps.open_find_textbook_each_order_popup}
          ></OrderManageArea>
        );
      }
      return (
        <td key={idx} className={td_class_name}
          onClick={() => {
            if (column["key"] == "a_user_name") {
              // myProps.select_show_write_page({
              //   selected_row: [info]
              // });
            }
          }}>
          <div className={td_div_class_name}>
            {val_str}
          </div>
        </td>
      );
    });
    return td_tags;
  };

  return (
    <tr>
      <td>
        <div className="row-col-div">
          <input type="checkbox"
            checked={is_select_row}
            onChange={select_check_toggle}
            style={{ width: 20, height: 20 }} />
        </div>
      </td>
      {get_td_tags()}
    </tr>
  );
};
export default RowArea;